import { render, staticRenderFns } from "./MemberSendMail.vue?vue&type=template&id=9584b1b4&scoped=true&"
import script from "./MemberSendMail.vue?vue&type=script&lang=js&"
export * from "./MemberSendMail.vue?vue&type=script&lang=js&"
import style0 from "./MemberSendMail.vue?vue&type=style&index=0&id=9584b1b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9584b1b4",
  null
  
)

export default component.exports